<template>
  <div>
    <v-dialog v-model="errorModal" width="500">
      <v-card>
        <v-card-title :class="`headline accent-3 ${color}`" primary-title>
          {{ this.color == "red" ? "Error" : "Success" }}
        </v-card-title>

        <v-card-text>
          {{ errorMsg }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red accent-3" flat @click="errorModal = false">
            close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-container>
      <v-toolbar flat color="white">
        <v-toolbar-title>Loan Products</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
          align="center"
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="600px">
          <template v-slot:activator="{ on }">
            <v-btn color="primary" dark class="mb-2" v-on="on">
              New Loan Product
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">New Loan Product</span>
            </v-card-title>

            <v-card-text>
              <v-container grid-list-md>
                <v-form ref="loan_product_form" v-model="valid" lazy-validation>
                  <v-text-field
                    v-model="newLoanProduct.product_title"
                    label="Title *"
                    :rules="[(v) => !!v || 'Title is required']"
                  ></v-text-field>
                  <v-text-field
                    v-model="newLoanProduct.product_subtitle"
                    label="Subtitle *"
                    :rules="[(v) => !!v || 'Subtitle is required']"
                  ></v-text-field>

                  <v-switch
                    v-model="newLoanProduct.status"
                    :label="newLoanProduct.status ? 'Enabled' : 'Disabled'"
                  ></v-switch>
                </v-form>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="close">Cancel</v-btn>
              <v-btn
                color="blue darken-1"
                flat
                :loading="loading"
                :disabled="loading || !valid"
                @click="save"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>

      <v-data-table
        :headers="headers"
        :loading="dataLoading"
        :items="loanProducts"
        :rows-per-page-items="[10, 20, 50, 100, 500]"
        :pagination.sync="pagination"
        :search="search"
        class="elevation-1"
      >
        <template v-slot:items="loanProducts">
          <td class="text-xs-center">{{ loanProducts.index + 1 }}</td>
          <td class="text-xs-center">{{ loanProducts.item.product_title }}</td>
          <td class="text-xs-center">
            {{ loanProducts.item.product_subtitle }}
          </td>
          <td class="text-xs-center">
            {{ loanProducts.item.status ? "Active" : "Inactive" }}
          </td>
          <td class="justify-center layout px-0">
            <router-link
              :to="{
                name: 'LoanProductDetails',
                params: { id: loanProducts.item.id },
              }"
            >
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon small label="Details" v-on="on">
                    content_paste_go
                  </v-icon>
                </template>
                <span>Details</span>
              </v-tooltip>
            </router-link>
          </td>
        </template>

        <template v-slot:no-data v-if="!dataLoading">
          <v-btn color="primary" @click="initialize">Restore</v-btn>
        </template>
      </v-data-table>
    </v-container>
  </div>
</template>
<script>
  import HTTP from "@/utils/HTTP";
  import { loanProductsUrl, loanProductUrl } from "@/utils/variables";

  export default {
    data: () => ({
      dialog: false,
      loading: false,
      dataLoading: false,
      pagination: {
        rowsPerPage: 20,
      },
      search: "",
      headers: [
        {
          text: "Serial No",
          align: "center",
          value: "serial_no",
          sortable: true,
        },
        {
          text: "Title",
          align: "center",
          value: "product_title",
          sortable: true,
        },
        {
          text: "Subtitle",
          align: "center",
          value: "product_subtitle",
          sortable: true,
        },
        {
          text: "Active",
          align: "center",
          value: "status",
          sortable: true,
        },
        { text: "Actions", align: "center", value: "actions" },
      ],
      loanProducts: [],
      valid: true,
      color: "",
      errorModal: false,
      errorMsg: "",
      newLoanProduct: {
        product_title: "",
        product_subtitle: "",
        status: 1,
      },
      defaultItem: {
        product_title: "",
        product_subtitle: "",
        status: 1,
      },
    }),

    watch: {
      dialog(val) {
        val || this.close();
      },
    },

    created() {
      this.initialize();
    },

    methods: {
      async initialize() {
        try {
          this.dataLoading = true;
          const response = await HTTP().get(loanProductsUrl);
          this.loanProducts = response.data.data;
          this.dataLoading = false;
        } catch (error) {
          this.color = "red";
          this.errorMsg = "Something went wrong";
          this.errorModal = true;
        }
      },

      close() {
        this.dialog = false;
        setTimeout(() => {
          this.newLoanProduct = Object.assign({}, this.defaultItem);
        }, 300);
      },

      async save() {
        await this.$refs.loan_product_form.validate();
        if (this.valid) {
          try {
            this.loading = true;
            this.newLoanProduct.status = this.newLoanProduct.status ? 1 : 0;
            const response = await HTTP().post(
              loanProductUrl,
              this.newLoanProduct
            );
            if (response.data && response.data.error == 0) {
              //   this.initialize();
              this.loanProducts.push(response.data.data);
              this.close();
              this.color = "green";
              this.errorMsg = "Added Successfully";
              this.errorModal = true;
            } else {
              this.color = "red";
              this.errorMsg = response.data.errorMsg;
              this.errorModal = true;
            }

            this.loading = false;
          } catch (error) {
            this.color = "red";
            this.errorMsg = "Something went wrong";
            this.errorModal = true;
            this.loading = false;
          }
        }
      },
    },
  };
</script>
<style scoped>
  a {
    text-decoration: none;
    margin-top: 18px;
  }
</style>
